import { useMutation } from '@hooks/reactQuery';

import { checkAssetTypeName } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { CHECK_ASSET_SUBTYPE_NAME } from '@constants/queryKeys';

export const useMutateCheckAssetTypeName = () => {
	const {
		mutateAsync: handleCheckAssetTypeName,
		isLoading: isLoadingCheckAssetTypeName,
	} = useMutation<string>({
		mutationKey: [CHECK_ASSET_SUBTYPE_NAME],
		mutationFn: checkAssetTypeName,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCheckAssetTypeName,
		isLoadingCheckAssetTypeName,
	};
};
